export default __webpack_public_path__ + "static/media/enderima.9769cbb7.jpg";